<div
	class="fill"
	[style.width]="parseValue()"
	[style.background-color]="ColorMap[color]">
</div>